export default "__VITE_ASSET__C44zoPjN__"